module.exports = __webpack_public_path__ + "static/media/collectionDiamond.f86d71cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collectionDiamond.svg
// module id = 146
// module chunks = 0